import React from "react";

/**
 * Tiny error boundary. Catches render errors from any descendant and renders
 * an optional `fallback` instead of crashing the whole page. Useful around
 * non-critical UI (e.g. Lightbox) so a runtime bug in the viewer can't
 * blank the entire detail screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
